import React, { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import "../Layout/Layout.css";
import Icard from "../Icard/Icard";

const Layout = () => {
  const [isIcardOpen, setIsIcardOpen] = useState(false);

  const handleMouseMove = (e, card) => {
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * 20;
    const rotateY = ((centerX - x) / centerX) * 20;

    gsap.to(card, {
      duration: 0,
      rotationX: rotateX,
      rotationY: rotateY,
      transformPerspective: 1500,
      ease: "power3.out",
    });
  };

  const handleMouseLeave = (card) => {
    gsap.to(card, {
      duration: 0,
      rotationX: 0,
      rotationY: 0,
      ease: "power3.out",
    });
  };

  const openIcard = () => {
    setIsIcardOpen(true);
  };

  const closeIcard = () => {
    setIsIcardOpen(false);
  };

  return (
    <div className="layout-section">
      {isIcardOpen && <Icard onClose={closeIcard} />}
      <h1 className="layout-heading">Our Layouts</h1>
      <div className="card-container">
        <div
          className="card"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
          onClick={openIcard}
        >
          <img src="/l1.webp" alt="Layout 1" className="card-image" />
          <div className="card-bar">Super Area (2452 sq.ft.)</div>
        </div>
        <div
          className="card"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
          onClick={openIcard}
        >
          <img src="/l1s.webp" alt="Layout 2" className="card-image" />
          <div className="card-bar">3 BHK + Servant (2452 sq.ft.)</div>
        </div>
      </div>
      <div className="card-container">
        <div
          className="card"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
          onClick={openIcard}
        >
          <img src="/l2.webp" alt="Layout 1" className="card-image" />
          <div className="card-bar">Super Area (2165 sq.ft.)</div>
        </div>
        <div
          className="card"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
          onClick={openIcard}
        >
          <img src="/l2s.webp" alt="Layout 2" className="card-image" />
          <div className="card-bar">3 BHK + Servant (2165 sq.ft.)</div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
